module.exports = __webpack_public_path__ + "img/1557614082730827779.bbeb7cbe.png";